import React from 'react';
import { HeartIcon } from 'lucide-react';
import { Avatar } from './Avatar';
import { findPerson } from '../data/people';
import { useLocale } from '../contexts/LocaleContext';
import { useSocial } from '../contexts/SocialContext';
import type { Comment, CommentReply } from '../types';
function Row({
  entry,
  nested = false
}: {
  entry: CommentReply;
  nested?: boolean;
}) {
  const {
    t,
    tl
  } = useLocale();
  const social = useSocial();
  const author = findPerson(entry.authorId);
  const liked = social.isCommentLiked(entry.id);
  return <div className={`flex gap-2 ${nested ? 'pl-5' : ''}`} data-id="element-535" data-mp="4zj08d291i77">
      <Avatar src={author.avatar} name={author.name} size={nested ? 28 : 34} data-id="element-536" data-mp="joyp1ni7zdk9" />
      <div className="min-w-0 flex-1" data-id="element-537" data-mp="epug8xz7jhug">
        <p className="text-[12.5px] font-medium text-deep" data-id="element-538" data-mp="eqx755wj5kad">
          {author.name}
          <span className="ml-1 font-normal text-muted" data-id="element-539" data-mp="soloi3re29ao">
            · {t('post.hoursAgo', {
            n: entry.hoursAgo
          })}
          </span>
        </p>
        <p className="mt-[2px] text-[13px] leading-relaxed text-deep" data-id="element-540" data-mp="no7ier9cl9fa">
          {tl(entry.text)}
        </p>
        <button type="button" onClick={() => social.likeComment(entry.id)} aria-pressed={liked} className={`mt-1 flex min-h-[32px] items-center gap-1 text-[11px] font-medium transition-colors duration-150 ease-brand ${liked ? 'text-gold-deep' : 'text-muted hover:text-deep'}`} data-id="element-541" data-mp="2gjp6g8o10voo">
          <HeartIcon size={13} fill={liked ? 'currentColor' : 'none'} data-id="element-542" data-mp="2zf5lyia4i31m" />
          <span className="bee-num" data-id="element-543" data-mp="34f07s7f1k2ft">{entry.likes + (liked ? 1 : 0)}</span>
        </button>
      </div>
    </div>;
}
export function CommentItem({
  comment
}: {
  comment: Comment;
}) {
  return <li className="border-b border-sand-line py-2 last:border-b-0" data-id="element-544" data-mp="3e4tmviee6zot">
      <Row entry={comment} data-id="element-545" data-mp="3e75zrh5amjv0" />
      {comment.replies.length > 0 && <ul className="mt-2 space-y-2" data-id="element-546" data-mp="3j5h97qroescp">
          {comment.replies.map(reply => <li key={reply.id} data-id="element-547" data-mp="3n6t4ocx8e7st">
              <Row entry={reply} nested data-id="element-548" data-mp="3n616cuc91vyu" />
            </li>)}
        </ul>}
    </li>;
}